import React from 'react';
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';

/**
 * Sección de domicilio reutilizable para formularios PLD.
 * @param {object}   props
 * @param {object}   props.data      Objeto con los campos pld_* de domicilio
 * @param {Function} props.onChange  Callback(fieldName, value) para actualizar el padre
 * @param {Array}    props.paises    Catálogo de países [{ clave, nombre }]
 * @param {string}   [props.titulo]  Título de la sección (por defecto "C. Domicilio")
 */
export default function FormDomicilio({ data, onChange, paises, titulo = 'C. Domicilio' }) {
    function handle(field) {
        return (e) => onChange(field, e.target.value);
    }

    return (
        <>
            <h6 className="text-primary text-uppercase border-bottom pb-2 mb-3 mt-4">
                <FontAwesomeIcon icon={faMapMarkerAlt} className="mr-2" />
                {titulo}
            </h6>
            <Row>
                <Col md="4">
                    <FormGroup>
                        <Label className="small font-weight-bold text-muted text-uppercase">
                            Calle
                        </Label>
                        <Input
                            value={data.pld_calle || ''}
                            onChange={handle('pld_calle')}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label className="small font-weight-bold text-muted text-uppercase">
                            No. ext.
                        </Label>
                        <Input
                            value={data.pld_num_ext || ''}
                            onChange={handle('pld_num_ext')}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label className="small font-weight-bold text-muted text-uppercase">
                            No. int.
                        </Label>
                        <Input
                            value={data.pld_num_int || ''}
                            onChange={handle('pld_num_int')}
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className="small font-weight-bold text-muted text-uppercase">
                            Colonia
                        </Label>
                        <Input
                            value={data.pld_colonia || ''}
                            onChange={handle('pld_colonia')}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label className="small font-weight-bold text-muted text-uppercase">
                            C.P.
                        </Label>
                        <Input
                            maxLength={5}
                            value={data.pld_cp || ''}
                            onChange={handle('pld_cp')}
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className="small font-weight-bold text-muted text-uppercase">
                            Ciudad, Alcaldía o Municipio
                        </Label>
                        <Input
                            value={data.pld_ciudad || ''}
                            onChange={handle('pld_ciudad')}
                        />
                    </FormGroup>
                </Col>
                <Col md="4">
                    <FormGroup>
                        <Label className="small font-weight-bold text-muted text-uppercase">
                            Estado
                        </Label>
                        <Input
                            value={data.pld_estado || ''}
                            onChange={handle('pld_estado')}
                        />
                    </FormGroup>
                </Col>
                <Col md="2">
                    <FormGroup>
                        <Label className="small font-weight-bold text-muted text-uppercase">
                            País
                        </Label>
                        <Input
                            type="select"
                            value={data.pld_pais_domicilio || 'MEX'}
                            onChange={handle('pld_pais_domicilio')}
                        >
                            {(paises || []).map((p) => (
                                <option key={p.clave} value={p.clave}>
                                    {p.nombre}
                                </option>
                            ))}
                        </Input>
                    </FormGroup>
                </Col>
            </Row>
        </>
    );
}
